/** useState key: active competition DTO for quiz play (set in route middleware, read on page). */
export const NATJECANJA_QUIZ_PLAY_COMPETITION_STATE_KEY = 'natjecanja-quiz-play-active-competition-v1'
